'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Gallery = exports.GalleryDelete = undefined;

var _gallery = require('./gallery');

var _gallery2 = _interopRequireDefault(_gallery);

var _gallery_delete = require('./gallery_delete');

var _gallery_delete2 = _interopRequireDefault(_gallery_delete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GalleryDelete = _gallery_delete2.default;
exports.Gallery = _gallery2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/gallery/index.js
// module id = 2237
// module chunks = 0